import React from "react";
interface props {
  className?: string;
}
function YoutubeSvg({ className }: props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      className={className}
      fill="none"
      viewBox="0 0 21 20"
    >
      <g clipPath="url(#clip0_1181_943)" opacity="0.8">
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M8.035 12.391V7.095l5.093 2.657-5.093 2.64zM19.22 6.176s-.184-1.299-.75-1.87c-.716-.752-1.52-.755-1.888-.799-2.638-.19-6.595-.19-6.595-.19h-.008s-3.958 0-6.595.19c-.37.043-1.172.047-1.89.798-.565.572-.749 1.871-.749 1.871S.556 7.703.556 9.227v1.431c0 1.526.188 3.051.188 3.051s.184 1.299.749 1.871c.718.751 1.66.728 2.079.806 1.508.145 6.41.19 6.41.19s3.961-.006 6.599-.197c.369-.044 1.172-.048 1.889-.799.565-.572.75-1.87.75-1.87s.188-1.526.188-3.052v-1.43c0-1.525-.189-3.052-.189-3.052z"
          clipRule="evenodd"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1181_943">
          <path
            fill="#fff"
            d="M0 0H19.889V19.889H0z"
            transform="translate(.555)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default YoutubeSvg;
